import { render, staticRenderFns } from "./bigbuy.vue?vue&type=template&id=3c5f7c56&scoped=true"
import script from "./bigbuy.vue?vue&type=script&lang=js"
export * from "./bigbuy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5f7c56",
  null
  
)

export default component.exports